export class EnvironmentsShared {
	static apis3rd = {
		botmaker: 'https://go.botmaker.com/rest/webchat/p/58I58P1WGD/init.js',
		correiosBuscaCep: 'https://buscacepinter.correios.com.br/app/endereco',
		servicodadosIbge: 'https://servicodados.ibge.gov.br/api/v1',
		viaCep: 'https://viacep.com.br/ws',
	};

	static sentry = {
		dsn: 'https://09cc5c6ab3534fb4b30e615acaaa5221@o4505037827932160.ingest.us.sentry.io/4505047226318848',
	};
}
